export const selectYouboraCode = state => {
    return state.config?.player_settings?.analytics.youboraAccount;
};
